import { ThunkType } from "../../../../core/store/reducers";
import { deleteOrderIndApi } from "../api/deleteOrderInd";
import { setFetchState, invalidateorderInd } from "../orderIndDataReducer";
import { loadAllOrderInd } from "./loadAllOrderInd";

export const deleteOrderInd = (orderid: number): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = await dispatch(deleteOrderIndApi(userId, orderid));

  dispatch(
    setFetchState(
      result !== undefined ? { type: "successful" } : { type: "error" }
    )
  );
  
  dispatch(invalidateorderInd());
  dispatch(loadAllOrderInd());
};
